export const outcomes = [
  'Establish a consistent starting point for unfamiliar TCM jobs.',
  'Organize identification information.',
  'Document diagnostic symptoms and findings.',
  'Structure the investigation of communication and reading problems.',
  'Evaluate tool requirements and compatibility.',
  'Prepare the documentation required before an intervention.',
  'Record files, versions, and backups where applicable.',
  'Document verification results.',
  'Create a repeatable workshop process.',
]
